import React from "react";
import { usePublicPageSection } from "../../../../hooks/usePublicPageSection";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import { useLanguage } from "../../../../context/LanguageContext";
import "./OurValues.css";

const requireField = (fields, key) => {
  const value = fields?.[key];
  if (value == null || String(value).trim() === "") {
    throw new Error(`Our values field "${key}" is missing from the API response.`);
  }
  return value;
};

const requireMediaUrl = (section, groupKey) => {
  const item = section.media?.groups?.[groupKey]?.[0] || null;
  if (!item?.url) {
    throw new Error(`Our values media group "${groupKey}" is missing from the API response.`);
  }
  return resolveMediaUrl(item.url);
};

const buildModel = (section) => {
  const f = section.fields || {};
  return {
    badge: requireField(f, "badge"),
    title: requireField(f, "title"),
    values: [
      {
        title: requireField(f, "value1Title"),
        text: requireField(f, "value1Text"),
        icon: requireMediaUrl(section, "value-1"),
      },
      {
        title: requireField(f, "value2Title"),
        text: requireField(f, "value2Text"),
        icon: requireMediaUrl(section, "value-2"),
      },
      {
        title: requireField(f, "value3Title"),
        text: requireField(f, "value3Text"),
        icon: requireMediaUrl(section, "value-3"),
      },
      {
        title: requireField(f, "value4Title"),
        text: requireField(f, "value4Text"),
        icon: requireMediaUrl(section, "value-4"),
      },
    ],
  };
};

const OurValues = () => {
  const { meta } = useLanguage();
  const { model, error, isLoading } = usePublicPageSection(
    "about",
    "our-values",
    buildModel
  );

  if (isLoading) {
    return (
      <section className="our-values" dir={meta.dir}>
        <div className="our-values__container">
          <p style={{ color: "#64748b", fontSize: 14 }}>Loading…</p>
        </div>
      </section>
    );
  }

  if (error || !model) {
    return (
      <section className="our-values" dir={meta.dir}>
        <div className="our-values__container">
          <p style={{ color: "#b91c1c", fontSize: 14 }}>
            {error || "Our values unavailable."}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="our-values" dir={meta.dir}>
      <div className="our-values__container">
        <div className="our-values__header">
          <span className="our-values__badge">{model.badge}</span>
          <h2 className="our-values__title">{model.title}</h2>
        </div>

        <div className="our-values__grid">
          {model.values.map((value) => (
            <article key={value.title} className="our-values__item">
              <div className="our-values__icon">
                <img src={value.icon} alt="" aria-hidden="true" />
              </div>
              <h3 className="our-values__item-title">{value.title}</h3>
              <p className="our-values__item-text">{value.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurValues;
